<template>
<div width="100%">
    <div class="my-md-n10px">
        <v-row>
            <v-col cols="6" md="4" v-for="giftcard in giftcards" :key="giftcard._id">
                <div class="py-md-10px">
                    <div class="border">
                        <v-img :src="`https://salerbookcash.com` + giftcard.thumb" max-width="500" :aspect-ratio="500/500" contain></v-img>
                    </div>
                    <div class="text-center py-12px py-md-16px">
                        <div class="tit tit--xs text-truncate" >{{ giftcard.name }}</div>
                        <div class="font-size-16 font-size-md-18 mt-6px"><b class="primary--text">{{ giftcard.faceamt.format() }}</b> 원</div>
                    </div>
                    <div>
                        <v-btn large block color="primary" @click="order(giftcard)">구매하기</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>

    <div class="mt-30px mt-md-40px">
        <v-pagination v-model="page" :length="pageCount" color="primary" total-visible="11" @input="search(true)" />
    </div>

    <giftcard-dialog ref="giftcardDialog" />
    <login-dialog ref="loginDialog" />
    <kcb-cert ref="kcbCert" />

</div>
</template>
<script>
import api from "@/api";
import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";
import GiftcardDialog from "./giftcard-dialog.vue";
import LoginDialog from "../../login/login-dialog.vue";
export default {
    components: {
        GiftcardDialog,
        LoginDialog,
        KcbCert
    },
    props: {
        category: { type: Object },
        mode: { type: String, default: "mobile"},
        searchKey: { type: String },
        searchValue: { type: String },
    },
    data(){
        return {
            filter: {
                category: this.$props.category?.code,
                mode: this.$props.mode,
                searchKey: this.$props.searchKey || "",
                searchValue: this.$props.searchValue || "",
            },

            page: 1,
            pageCount: 0,
            limit: 18,

            giftcards: [],
            me: null
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        // 로컬 테스트용
        // async getAccessToken(){
        //     await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert: "622af4183dae29e48d8a3e08" });
        //     alert(this.$store.state.payload);
        //     alert(this.$store.state.scope);
        // },
        init(){
            this.search(false);
        },
        async search(routable = false){

            this.giftcards = [];
            let { summary, giftcards } = await api.v1.gshop.giftcards.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter,
            });

            let { me } = await api.v1.me.profile.get();
            this.me = me;

            this.giftcards = giftcards;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },

        certificate(){
            return new Promise((resolve, reject) => {
                if(this.scope?.includes?.("cert")) resolve();
                else {
                    this.$refs.kcbCert.$off();
                    this.$refs.kcbCert.$on("input", async ({ _cert }) => {
                        console.log(_cert)
                        await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert });
                        resolve();
                    });

                    this.$refs.kcbCert.open();
                }
            });
        },
        order(giftcard){
            if(!this.me.ci){
                alert("구매 권한이 없습니다.\n[로그인 > 마이페이지 > 회원정보수정 > 본인인증받기] 등록 후 이용해주세요.")
                this.$router.push('/mypage/profile')
                return;
            }
            this.login().then(this.certificate).then(async _ => {
                this.$refs.giftcardDialog.giftcard = giftcard;
                this.$refs.giftcardDialog.open();
            });
        }
    },
    computed: {
        refreshToken(){ return this.$store.state.refreshToken },
        accessToken(){ return this.$store.state.accessToken; },
        scope(){ return this.$store.state.scope },
        logon(){ return !!this.accessToken },
    },
    watch: {
        "filter.mode"(){ this.search(true); },
        "filter.searchValue"(){ this.search(true); },
        "$props.mode"(){ this.filter.mode = this.mode; },
        "$props.searchKey"(){ this.filter.searchKey = this.searchKey; },
        "$props.searchValue"(){ this.filter.searchValue = this.searchValue; },
        category(){
            this.page = 1;
            this.filter.category = this.category.code;
            this.search(true);
        }
    }
}
</script>

<style scoped>
.v-btn-toggle>>>.v-btn {
    opacity: 1 !important;
}
</style>